import { render } from "./안과.vue?vue&type=template&id=7760610f"
import script from "./안과.vue?vue&type=script&lang=js"
export * from "./안과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__